"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MappingClientV2 = void 0;
const tslib_1 = require("tslib");
const crud_client_1 = require("./crud.client");
class MappingClientV2 extends crud_client_1.CrudClient {
    constructor() {
        super(...arguments);
        this.version = 'v2';
        this.entityPath = 'mappings';
    }
    includeTargetFiltersV2(projectId, mappingId, pageId, filters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/mappings/${mappingId}/pages/${pageId}/include-target-filters?`;
            const response = yield this.httpPut(url, filters);
            return response.payload;
        });
    }
    excludeTargetFiltersV2(projectId, mappingId, pageId, filters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/mappings/${mappingId}/pages/${pageId}/exclude-target-filters?`;
            const response = yield this.httpPut(url, filters);
            return response.payload;
        });
    }
    deleteTargetFiltersV2(projectId, mappingId, pageId, filters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/mappings/${mappingId}/pages/${pageId}/delete-target-filters?`;
            const response = yield this.httpPut(url, filters);
            return response.payload;
        });
    }
    moveTargetFiltersV2(projectId, mappingId, pageId, destinationPage, filters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryString = this.getQueryString({ destinationPage });
            const url = `/v2/projects/${projectId}/mappings/${mappingId}/pages/${pageId}/move-target-filters?${queryString}`;
            const response = yield this.httpPut(url, filters);
            return response.payload;
        });
    }
}
exports.MappingClientV2 = MappingClientV2;
//# sourceMappingURL=mapping.v2.client.js.map